import { AxiosResponse } from 'axios';
import { axiosInstance } from '..';

export const getListAtc = async (
  page = 1, 
  pageSize = 10, 
  filters: {
    emissionDateFrom?: string;
    emissionDateTo?: string;
    statusIds?: number[]; 
    priceStatuses?: string[];
    solpedNumbers?: string[];
    atcNumbers?: string[]; 
    otNumbers?: string[];  
    supervisorsList?: string[];
    businessUnits?: string[];
    subtypeIds?: number[];
    workTypes?: string[];
    solpedStatuses?: boolean[];
    hesStatuses?: boolean[];
    ocStatuses?: boolean[];
    graphNumbers?: string[];
    supplierIds?: number[];
    searchAtcNumber?: string;
    centers?: string[];
    ocNumbers?: string[];
    statusGeneralIds?: number[];
  } = {}
) => {
  try {
    const params = new URLSearchParams();
    
    params.append('page', page.toString());
    params.append('pageSize', pageSize.toString());
    
    if (filters.emissionDateFrom) params.append('emissionDateFrom', filters.emissionDateFrom);
    if (filters.emissionDateTo) params.append('emissionDateTo', filters.emissionDateTo);

    if (filters.searchAtcNumber) params.append('searchAtcNumber', filters.searchAtcNumber);
    
    if (filters.centers && filters.centers.length > 0) {
      filters.centers.forEach(center => {
        params.append('centers', center);
      });
    }
    
    if (filters.atcNumbers && filters.atcNumbers.length > 0) {
      filters.atcNumbers.forEach(num => {
        params.append('atcNumbers', num);
      });
    }
    
    if (filters.otNumbers && filters.otNumbers.length > 0) {
      filters.otNumbers.forEach(num => {
        params.append('otNumbers', num);
      });
    }
    
    if (filters.statusIds && filters.statusIds.length > 0) {
      filters.statusIds.forEach(id => {
        params.append('statusIds', id.toString());
      });
    }
    
    if (filters.priceStatuses && filters.priceStatuses.length > 0) {
      filters.priceStatuses.forEach(status => {
        params.append('priceStatuses', status);
      });
    }
    
    if (filters.solpedNumbers && filters.solpedNumbers.length > 0) {
      filters.solpedNumbers.forEach(num => {
        params.append('solpedNumbers', num);
      });
    }
    
    if (filters.supervisorsList && filters.supervisorsList.length > 0) {
      filters.supervisorsList.forEach(supervisor => {
        params.append('supervisorsList', supervisor);
      });
    }

    if (filters.workTypes && filters.workTypes.length > 0)  {
      filters.workTypes.forEach(num => {
        params.append('workTypes', num);
      });
    }
    
    if (filters.businessUnits && filters.businessUnits.length > 0) {
      filters.businessUnits.forEach(unit => {
        params.append('businessUnits', unit);
      });
    }

    if (filters.subtypeIds && filters.subtypeIds.length > 0) {
      filters.subtypeIds.forEach(id => {
        params.append('subtypeIds', id.toString());
      });
    }

    if (filters.ocNumbers && filters.ocNumbers.length > 0) {
      filters.ocNumbers.forEach(num => {
        params.append('ocNumbers', num);
      });
    }
    
    if (filters.graphNumbers && filters.graphNumbers.length > 0) {
      filters.graphNumbers.forEach(num => {
        params.append('graphNumbers', num);
      });
    }
    
    if (filters.solpedStatuses && filters.solpedStatuses.length > 0) {
      filters.solpedStatuses.forEach(status => {
        params.append('solpedStatuses', status.toString());
      });
    }
    
    if (filters.hesStatuses && filters.hesStatuses.length > 0) {
      filters.hesStatuses.forEach(status => {
        params.append('hesStatuses', status.toString());
      });
    }
    
    if (filters.ocStatuses && filters.ocStatuses.length > 0) 
      params.append('ocStatuses', filters.ocStatuses.join(','));

    if (filters.supplierIds && filters.supplierIds.length > 0) {
      filters.supplierIds.forEach(id => {
        params.append('supplierIds', id.toString());
      });
    }

    if (filters.statusGeneralIds && filters.statusGeneralIds.length > 0) {
      filters.statusGeneralIds.forEach(id => {
        params.append('statusGeneralIds', id.toString());
      });
    }

    const response = await axiosInstance.get('WorkRecords/ListAtc', {
      params: params,
      paramsSerializer: { indexes: null } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching ATC list:', error);
    throw error;
  }
};

export const getAtcNumberList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/AtcNumberList');
    return response.data;
  } catch (error) {
    console.error('Error fetching ATC number list:', error);
    throw error;
  }
};

export const getOtNumberList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/OtNumberList');
    return response.data;
  } catch (error) {
    console.error('Error fetching OT number list:', error);
    throw error;
  }
};

export const getGraphNumberList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/GraphNumberList');
    return response.data;
  } catch (error) {
    console.error('Error fetching Graph number list:', error);
    throw error;
  }
};

export const getStatusATCList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/ListStatusAtc');
    return response.data;
  } catch (error) {
    console.error('Error fetching status atc list:', error);
    throw error;
  }
};

export const getStatusPriceList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/StatusPriceList');
    return response.data;
  } catch (error) {
    console.error('Error fetching status price list:', error);
    throw error;
  }
};

export const getSolpedNumberList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/SolpedNumberList');
    return response.data;
  } catch (error) {
    console.error('Error fetching solped number list:', error);
    throw error;
  }
};

export const getSupervisorList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/SupervisorList');
    return response.data;
  } catch (error) {
    console.error('Error fetching supervisor list:', error);
    throw error;
  }
};

export const getBusinessUnitList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/BusinessUnitList');
    return response.data;
  } catch (error) {
    console.error('Error fetching businees unit list:', error);
    throw error;
  }
};


export const getWorkTypeList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/WorkTypeList');
    return response.data;
  } catch (error) {
    console.error('Error fetching work type list:', error);
    throw error;
  }
};

export const getSolpedStatusList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/SolpedStatusList');
    return response.data;
  } catch (error) {
    console.error('Error fetching status solped list:', error);
    throw error;
  }
};

export const getHesStatusList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/HesStatusList');
    return response.data;
  } catch (error) {
    console.error('Error fetching status hes list:', error);
    throw error;
  }
};

export const getAtcDetail = async (recordId) => {
  try {
    const response = await axiosInstance.get(`WorkRecords/GetAtcDetail/${recordId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching ATC detail:', error);
    throw error;
  }
};

export const observeAtc = async (data: {
  recordIds: number[];
  reason: string;
  observation: string;
}) => {
  try {
    const response = await axiosInstance.put('WorkRecords/ObserveAtc', data);
    return response.data;
  } catch (error) {
    console.error('Error observing ATC:', error);
    throw error;
  }
};

export const getSubtypeList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/SubtypeList');
    return response.data;
  } catch (error) {
    console.error('Error fetching subtype list:', error);
    throw error;
  }
};

export const getCentersList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/GetCentersAtc');
    return response.data;
  } catch (error) {
    console.error('Error fetching centers list:', error);
    throw error;
  }
};

export const getOcNumberList = async (supplierIds?: number[]) => {
  try {
    const params = new URLSearchParams();
    
    if (supplierIds && supplierIds.length > 0) {
      supplierIds.forEach(id => {
        params.append('supplierIds', id.toString());
      });
    }
    
    const response = await axiosInstance.get('WorkRecords/ListOcNumbers', {
      params: params,
      paramsSerializer: { indexes: null }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching OC number list:', error);
    throw error;
  }
};

export const exportExcelAdmin = async (
  filters: {
    emissionDateFrom?: string;
    emissionDateTo?: string;
    statusIds?: number[]; 
    priceStatuses?: string[];
    solpedNumbers?: string[];
    atcNumbers?: string[]; 
    otNumbers?: string[];  
    supervisorsList?: string[];
    businessUnits?: string[];
    subtypeIds?: number[];
    workTypes?: string[];
    solpedStatuses?: boolean[];
    hesStatuses?: boolean[];
    ocStatuses?: boolean[];
    graphNumbers?: string[];
    supplierIds?: number[];
    searchAtcNumber?: string;
    centers?: string[];
    ocNumbers?: string[];
    statusGeneralIds?: number[];
  } = {}
) => {
  try {
    const params = new URLSearchParams();
    
    if (filters.emissionDateFrom) params.append('emissionDateFrom', filters.emissionDateFrom);
    if (filters.emissionDateTo) params.append('emissionDateTo', filters.emissionDateTo);

    if (filters.searchAtcNumber) params.append('searchAtcNumber', filters.searchAtcNumber);
    
    if (filters.centers && filters.centers.length > 0) {
      filters.centers.forEach(center => {
        params.append('centers', center);
      });
    }
    
    if (filters.atcNumbers && filters.atcNumbers.length > 0) {
      filters.atcNumbers.forEach(num => {
        params.append('atcNumbers', num);
      });
    }
    
    if (filters.otNumbers && filters.otNumbers.length > 0) {
      filters.otNumbers.forEach(num => {
        params.append('otNumbers', num);
      });
    }
    
    if (filters.statusIds && filters.statusIds.length > 0) {
      filters.statusIds.forEach(id => {
        params.append('statusIds', id.toString());
      });
    }
    
    if (filters.priceStatuses && filters.priceStatuses.length > 0) {
      filters.priceStatuses.forEach(status => {
        params.append('priceStatuses', status);
      });
    }
    
    if (filters.solpedNumbers && filters.solpedNumbers.length > 0) {
      filters.solpedNumbers.forEach(num => {
        params.append('solpedNumbers', num);
      });
    }
    
    if (filters.supervisorsList && filters.supervisorsList.length > 0) {
      filters.supervisorsList.forEach(supervisor => {
        params.append('supervisorsList', supervisor);
      });
    }

    if (filters.workTypes && filters.workTypes.length > 0)  {
      filters.workTypes.forEach(num => {
        params.append('workTypes', num);
      });
    }
    
    if (filters.businessUnits && filters.businessUnits.length > 0) {
      filters.businessUnits.forEach(unit => {
        params.append('businessUnits', unit);
      });
    }

    if (filters.subtypeIds && filters.subtypeIds.length > 0) {
      filters.subtypeIds.forEach(id => {
        params.append('subtypeIds', id.toString());
      });
    }

    if (filters.ocNumbers && filters.ocNumbers.length > 0) {
      filters.ocNumbers.forEach(num => {
        params.append('ocNumbers', num);
      });
    }
    
    if (filters.graphNumbers && filters.graphNumbers.length > 0) {
      filters.graphNumbers.forEach(num => {
        params.append('graphNumbers', num);
      });
    }
    
    if (filters.solpedStatuses && filters.solpedStatuses.length > 0) {
      filters.solpedStatuses.forEach(status => {
        params.append('solpedStatuses', status.toString());
      });
    }
    
    if (filters.hesStatuses && filters.hesStatuses.length > 0) {
      filters.hesStatuses.forEach(status => {
        params.append('hesStatuses', status.toString());
      });
    }
    
    if (filters.ocStatuses && filters.ocStatuses.length > 0) 
      params.append('ocStatuses', filters.ocStatuses.join(','));

    if (filters.supplierIds && filters.supplierIds.length > 0) {
      filters.supplierIds.forEach(id => {
        params.append('supplierIds', id.toString());
      });
    }

    if (filters.statusGeneralIds && filters.statusGeneralIds.length > 0) {
      filters.statusGeneralIds.forEach(id => {
        params.append('statusGeneralIds', id.toString());
      });
    }

    const response = await axiosInstance.get('WorkRecords/ExportExcelAdmin', {
      params: params,
      paramsSerializer: { indexes: null },
      responseType: 'blob' 
    });
    
    let fileName = null;
    const contentDisposition = response.headers['content-disposition'];
    
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-8'')?([^'";\n]+)/i);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = decodeURIComponent(fileNameMatch[1]);
      } else {
        const simpleMatch = contentDisposition.match(/filename=['"]?([^'";\n]+)['"]?/i);
        if (simpleMatch && simpleMatch[1]) {
          fileName = simpleMatch[1];
        }
      }
    }
    

    return { data: response.data, fileName };
  } catch (error) {
    console.error('Error exporting Excel:', error);
    throw error;
  }
};

export const getAtcDashboardData = async (supplierId = null, criticity = null) => {
  try {
    let url = '/WorkRecords/WorkRecordsDashboard';
    const params = new URLSearchParams();
    
    if (supplierId) {
      params.append('supplierId', supplierId);
    }
    
    if (criticity) {
      params.append('criticity', criticity);
    }
    
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
    
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching ATC dashboard data:', error);
    throw error;
  }
};

export const getCountEmptyAtcs = async (
  startDate = null, 
  endDate = null, 
  supplierIds: number[] | null = null,
  criticity: string | null = null
) => {
  try {
    const params = new URLSearchParams();
    
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    
    if (supplierIds && supplierIds.length > 0) {
      supplierIds.forEach(id => {
        params.append('supplierIds', id.toString());
      });
    }
    
    if (criticity && criticity !== "Todas") {
      params.append('criticity', criticity);
    }
    
    const response = await axiosInstance.get('WorkRecords/CountEmptyAtcs', {
      params: params,
      paramsSerializer: { indexes: null }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error obteniendo conteo de ATCs vacías:', error);
    throw error;
  }
};

export const getStatusGeneralList = async () => {
  try {
    const response = await axiosInstance.get('WorkRecords/ListStatusGeneral');
    return response.data;
  } catch (error) {
    console.error('Error fetching status general list:', error);
    throw error;
  }
};